import * as angular from 'angular';

(function () {
    'use strict';

    angular.module('app').config(AdminRoute);

    /** @ngInject */
    function AdminRoute($stateProvider) {
        $stateProvider.state('admin', {
            url: '/panel-administracyjny',
            template: require('/builds/imieszkaniec.pl/iwykonawca/frontend/src/app/components/_admin/_admin.html'),
            controller: 'AdminController',
            controllerAs: 'AdminCtrl',
        });
    }
})();



// WEBPACK FOOTER //
// ./node_modules/angularjs-template-loader??ref--0-1!./src/app/components/_admin/_admin.route.ts